import { ObservationEnum } from "@/types/ObservationEnum";

export const linkToPractitionerMonitoringListKindOrders = (patientId: string, kind: ObservationEnum) => {
  return `/practitioner/orders/patient/${patientId}/monitoring/${kind}`;
};
export const linkToPractitionerPendedNotes = (): string => `/practitioner/pended-notes`;
export const linkToPractitionerFax = (): string => `/practitioner/fax`;
export const linkToPractitionerMeetingRoom = (): string => `/practitioner/meeting-room`;
export const linkToPractitionerPendedNotesPending = (): string => `/practitioner/pended-notes/pending`;
